const { default: VueRouter } = require("vue-router");
window.Vue = require("vue");

import Index from "../components/Index.vue";
import Blog from "../components/Noticies.vue";
import PostList from "../components/PostListComponent.vue";
import PostDetail from "../components/PostDetailComponent.vue";

Vue.use(VueRouter);

export default new VueRouter({
    mode: 'history',
    routes: [
        { path: "/", component: Index, name: "index" },
        { path: "/blog", component: Blog, name: "blog" },
        { path: "/list", component: PostList, name: "list" },
        { path: "/post/:id", component: PostDetail, name: "post" },
    ]
});